export default __webpack_public_path__ + "static/media/interface-24.f47a3498.svg";